import React from 'react';
import { Link } from 'react-router-dom';

const ProductItem = (props) => {
  const product = props;
  return (
    <>
      <div className="product_item p-2 col-6 col-md-4 col-lg-3 p-2" style={{ background: 'rgb(235,244,246)', position: 'relative' }}>
        <div className="h-100 p-2" style={{ background: 'white' }}>
          <Link key={`link_${product.id}`} to={`/product/${product.page}/${product.id}`} style={{ textDecoration: 'none', color: 'rgb(42,43,42)' }}>
            <div className="product_img mb-3">
              <img src={product.imgUrl} style={{ width: '100%' }} alt={product.name} />
            </div>
            {
              // eslint-disable-next-line no-nested-ternary
              product.label
                ? product.isSubscription
                  ? (
                    <div style={{
                      position: 'absolute',
                      right: '1rem',
                      top: '1rem',
                      background: 'rgb(239,151,45)',
                      color: 'white',
                      borderRadius: '25px',
                      padding: '0.3rem 1rem',
                    }}
                    >
                      定期便
                    </div>
                  )
                  : (
                    <div style={{
                      position: 'absolute',
                      right: '1rem',
                      top: '1rem',
                      background: 'rgb(62,170,218)',
                      color: 'white',
                      borderRadius: '2rem',
                      padding: '0.3rem 1rem',
                    }}
                    >
                      単品
                    </div>
                  )
                : ''
            }
            <div className="product_desc px-3 py-1">
              {/* <p className="text-left" style={{ marginBottom: '0.5rem' }}>{product.name}</p> */}
              <div
                className="text-left"
                style={{
                  marginBottom: process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',').includes(product?.id?.toLocaleString()) ? '3rem' : '2rem',
                }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: product.name }}
              />
              {
                process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',').includes(product?.id?.toLocaleString())
                  ? (
                    <p
                      className="text-right font-weight-bold small"
                      style={{
                        position: 'absolute',
                        bottom: '0px',
                        right: '15px',
                      }}
                    >
                      初回：￥&nbsp;5,400&nbsp;(税込)
                      <br />
                      2ヶ月目以降：￥&nbsp;9,720&nbsp;(税込)
                    </p>
                  ) : (
                    <p
                      className="text-right font-weight-bold"
                      style={{
                        position: 'absolute',
                        bottom: '10px',
                        right: '15px',
                      }}
                    >
                      ￥
                      {product.price.toLocaleString()}
                      &nbsp;(税込)
                    </p>
                  )
              }
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ProductItem;
